import "core-js/modules/es.array.reduce";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.replace";
import "core-js/modules/web.dom-collections.iterator";
import Vue from 'vue';
import Vuex from 'vuex';
import getters from './getters';
import { Message } from 'element-ui';
Vue.use(Vuex);

var modulesFiles = require.context('./modules', true, /\.js$/);

var modules = modulesFiles.keys().reduce(function (modules, modulePath) {
  // set './app.js' => 'app'
  var moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1');
  var value = modulesFiles(modulePath);
  modules[moduleName] = value.default;
  return modules;
}, {});
var store = new Vuex.Store({
  state: {
    message: undefined,
    tabelLoading: false
  },
  modules: modules,
  getters: getters,
  mutations: {
    showMessage: function showMessage(state, options) {
      if (state.message) {
        state.message.close();
      }

      state.message = Message({
        message: options.message,
        type: options.type || 'success',
        duration: options.duration || 2000,
        offset: 40
      });
    }
  }
});
export default store;